import { useSelector } from 'react-redux';
import { RootState } from '../../store';

export const Steps = () => {
  const stepper = useSelector((state: RootState) => state.stepper);

  return (
    <ul className="sticky top-0 z-10 bg-white justify-between items-center w-full md:flex md:my-5 mm:space-x-8 rtl:space-x-reverse">
      {stepper.steps.map((step) =>
        step.status === 'complete' ? (
          <li
            key={step.id}
            className="flex gap-4 p-4 items-center text-gray-900 text-sm text-left font-medium space-x-2.5 rtl:space-x-reverse"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
            >
              <rect width="40" height="40" rx="20" fill="#5556D6" />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.7071 15.2929C27.0976 15.6834 27.0976 16.3166 26.7071 16.7071L18.7071 24.7071C18.3166 25.0976 17.6834 25.0976 17.2929 24.7071L13.2929 20.7071C12.9024 20.3166 12.9024 19.6834 13.2929 19.2929C13.6834 18.9024 14.3166 18.9024 14.7071 19.2929L18 22.5858L25.2929 15.2929C25.6834 14.9024 26.3166 14.9024 26.7071 15.2929Z"
                fill="white"
              />
            </svg>
            {step.title}
          </li>
        ) : step.status === 'current' ? (
          <li
            key={step.id}
            className="flex gap-4 p-4 items-center text-purple-600 text-sm text-left font-medium space-x-2.5 rtl:space-x-reverse"
          >
            <span className="flex items-center justify-center w-10 h-10 border-2 border-purple-600 rounded-full shrink-0">
              {step.number}
            </span>
            {step.title}
          </li>
        ) : (
          <li
            key={step.id}
            className="flex gap-4 p-4 items-center text-gray-550 text-sm text-left font-medium space-x-2.5 rtl:space-x-reverse"
          >
            <span className="flex items-center justify-center w-10 h-10 border-2 border-gray-300 rounded-full shrink-0">
              {step.number}
            </span>
            {step.title}
          </li>
        )
      )}
    </ul>
  );
};
